import React from 'react'

import { Button, Card } from '@acorns/web-components'
import styled from 'styled-components'

import { Bodytext, Heading } from 'components/typography'
import { style } from 'theme'

const StyledCard = styled(Card)<{ isWebView: boolean }>`
  box-shadow: ${style((theme) => theme.shadows.lgMedium)};
  max-width: 800px;
  min-height: 300px;
  margin: 0 auto;
  padding: 30px 0;
  text-align: center;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    margin-top: 0;
    display: flex;
    width: 100%;
    padding: ${(props) => (props.isWebView ? '0 30px 50px;' : '50px 30px;')};
    justify-content: space-evenly;
    flex-direction: column;
  }
  @media screen and (max-width: 321px) {
    padding: 0px 20px 50px;
  }
`
const StyledImage = styled.img`
  height: 104px;
  width: 104px;
  margin: 0 auto;
  display: inline-block;
`

const StyledBody = styled(Bodytext)`
  max-width: 420px;
  display: block;
  margin: 30px auto;
  letter-spacing: 0px;
  line-height: 22px;
  text-align: center;
  @media screen and (max-width: 321px) {
    margin: 10 auto;
  }
`

const StyledCloseAccountButton = styled(Button)`
  width: 240px;
  margin: 0 auto;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    margin-top: auto;
    width: 100%;
  }
`

const StyledHeading = styled(Heading)`
  margin-top: 20px;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
`

const ManageContentHeader = styled(Heading)`
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
`

const RedStyledCloseAccountButton = styled(StyledCloseAccountButton)`
  background-color: ${style((theme) => theme.colors.red)} !important;
  margin-top: 50px;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    margin-top: 20px;
  }
`
const ImageBackground = styled.div`
  margin: 0 auto;
  background: #ffffff;
  box-shadow: ${style((theme) => theme.shadows.lgMedium)};
  height: 100px;
  width: 100px;
  z-index: 3;
  border-radius: 50%;
  display: flex;
  justify-content: center;
`
const ImgGroup = styled.div`
  height: 100px;
  width: 100px;
  position: relative;
  margin: 0 auto;
  margin-bottom: 30px;
  @media screen and (max-width: 320px) {
    margin-bottom: 0px;
  }
`
const OuterImageBackground = styled.div`
  height: 100px;
  width: 100px;
  z-index: 2;
`

const CenteredImage = styled(StyledImage)`
  height: 44px;
  width: 40px;
  margin: 0 auto;
  position: absolute;
  z-index: 6;
  left: 32px;
  top: 50%;
  transform: translateY(-50%);
`

const CircularIcon: React.FC<{ image?: string }> = ({ image, children }) => {
  return (
    <ImgGroup>
      <OuterImageBackground>
        <ImageBackground>
          {image && <CenteredImage src={image} />}
          {children}
        </ImageBackground>
      </OuterImageBackground>
    </ImgGroup>
  )
}
export {
  CircularIcon,
  StyledCard,
  StyledImage,
  StyledBody,
  StyledCloseAccountButton,
  StyledHeading,
  ManageContentHeader,
  RedStyledCloseAccountButton,
}
